import React, { useState, useEffect } from "react";
import { MainAdminNewsesTop, MainAdminTablesNews, MainAdminTablesScheduleNews } from "../../components"
import { axiosReq } from "../../commons/axiosReq";
import Cookies from 'universal-cookie';

const MainAdminPublishedNewses = () => {

    const titleRow = ["عنوان خبر", "دسته بندی", "تاریخ انتشار", "نویسنده"];
    const example = ["رشد ارز چه آثاری بر روی قیمت خودرو دارد؟", "طلا و ارز", "1403/04/16", "علیرضا بابایی"];

    const [showEditModal, setShowEditModal] = React.useState(false);
    const [showDeleteModal, setShowDeleteModal] = React.useState(false);
    const [data, setData] = useState();
    const [search, setSearch] = useState("");
    const [reCheck, setRecheck] = useState(false);
    const [count, setCount] = useState();
    const [page, setPage] = useState(1);
    const [row, setRow] = useState(10);
    const [cats, setCats] = useState();
    const [cat, setCat] = useState(0);
    const [start, setStart] = useState("");
    const [end, setEnd] = useState("");
    const [prominent, setProminent] = useState(false);
    const [last, setLast] = useState(false);
    const [most, setMost] = useState(false);
    const [main, setMain] = useState(false);
    const [admins, setAdmins] = useState();
    const [admin, setAdmin] = useState();

    const GetData = async () => {
        console.log("main:" + admin)
        // var ad = admin ? admin?.split("T")[1] == "Admin" ? admin?.split("T")[0] : 0 : 0
        // var ath = admin ? admin?.split("T")[1] == "Author" ? admin?.split("T")[0] : 0 : 0
        const writersData = await axiosReq("Article/GetScheduledArticles?page=" + page + "&&pageSize=" + row + "&&search=" + search + "&&category=" + cat + "&&startDate=" + start +
            "&&endDate=" + end 
            + "&&isProminent=" + prominent + "&&isLast=" + last + "&&isMostViewed=" + most + "&&mainPage=" + main, "get");
        console.log(writersData)
        setData(writersData?.data)
        setCount(writersData?.count)

      
     
       

       


    }
    const GetData2 = async () => {
    

        const mainCats = await axiosReq("Article/GetCategories", "get");
        console.log(mainCats)
        var catArr = [];
        mainCats?.data?.map((item) => {
            catArr.push({ value: item.categoryId, label: item.categoryName })
        })
        setCats(catArr)
        var catArr = [];
   const cookies = new Cookies();
//    if (cookies.get('role') == "Admin") {

//         const admins = await axiosReq("Article/GetAdmins", "get");
//         console.log(admins)
//         var adminArr = [];
//         admins?.data?.map((item) => {
//             adminArr.push({ value: item.adminId + "TAdmin", label: item.name + " " + item.family, isAdmin: true })
//         })
//         const authors = await axiosReq("Article/GetAuthor", "get");
//         console.log(authors)
//         authors?.data?.map((item) => {
//             adminArr.push({ value: item.authorId + "TAuthor", label: item.authorName + " " + item.authorFamily, isAdmin: false })
//         })


//         setAdmins(adminArr)
//     }
    }
    useEffect(() => {

        GetData();
    }, [reCheck, search, page, row, cat, start, end,
        admin, prominent, last, most, main]);

        useEffect(() => {

            GetData2();
        }, []);



    return (
        <div>
            <div><MainAdminNewsesTop mode={true} cats={cats} setCat={setCat} setStart={setStart} start={start} end={end} setEnd={setEnd}
            //  setAdmin={setAdmin}
                setProminent={setProminent} setLast={setLast} setMost={setMost} setMain={setMain}
                //  admins={admins}
            >اخبار منتشر شده</MainAdminNewsesTop></div>


            <div className="pt-[20px] px-[20px] pb-[280px]">
                <MainAdminTablesScheduleNews detail={true} edit={true} block={false} deleted={true}
                    setShowEditModal={setShowEditModal} setShowBlockModal={null} setShowDeleteModal={setShowDeleteModal}
                    titleRow={titleRow} example={example} data={data} setRecheck={setRecheck} reCheck={reCheck}
                    count={count} page={page} setPage={setPage} row={row} setRow={setRow} />
            </div>

        </div>
    )
}

export default MainAdminPublishedNewses;